import * as Preact from 'preact';
import Box from '@mui/material/Box';
import * as A_Button from './A_Button';
import { ReverseLeft } from './icons/reverseLeft';
import { ReverseRight } from './icons/reverseRight';
import CheckIcon from '@mui/icons-material/Check';

/**
 * Figma design node:
 * https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9668%3A59204
 */

export type Props = {
    done?: () => void;
    undo?: () => void;
    redo?: () => void;
    doneText: string;
    undoText: string;
    redoText: string;
    doneDisabled: boolean;
};

export const Component = (p: Props) => (
    <Box
        sx={{
            backgroundColor: 'background.default',
            display: 'flex',
            justifyContent: p.done ? 'space-between' : 'flex-start',
            alignItems: 'center',
            width: '100%',
            paddingX: '12px',
            boxSizing: 'border-box',
            borderTop: '1px #E0E0E0 solid',
        }}
    >
        <Box
            sx={{
                display: 'flex',
                gap: { xs: '6px', md: '11px' },
                height: { xs: '58px', md: '64px' },
            }}
        >
            <A_Button.Component
                startIcon={<ReverseLeft fontSize="medium" />}
                disabled={!p.undo}
                color="secondary"
                onClick={p.undo}
            >
                {p.undoText}
            </A_Button.Component>
            <A_Button.Component
                endIcon={<ReverseRight fontSize="medium" />}
                disabled={!p.redo}
                color="secondary"
                onClick={p.redo}
            >
                {p.redoText}
            </A_Button.Component>
        </Box>
        {p.done && (
            <A_Button.Component
                startIcon={<CheckIcon />}
                size="large"
                variant="contained"
                onClick={p.done}
                disabled={p.doneDisabled}
            >
                {p.doneText}
            </A_Button.Component>
        )}
    </Box>
);
